'use client';

import type { Page, CareersPage } from '../../lib/types';
import { usePathname } from 'next/navigation';
import PageBodyBackground from '../ui/PageBodyBackground';
import HeroCareers from '../ui/HeroCareers';
import Cookies from '../sections/Cookies';
import ThreeCardsStickyMobile from '../sections/ThreeCardsStickyMobile';
import ImagesWavyBg from '../sections/ImagesWavyBg';
import ListAccordion from '../sections/ListAccordion';
import ScrollForMoreOverlay from '../ui/ScrollForMoreOverlay';

type CareersLayoutProps = {
  page: Page;
};

export default function CareersLayout({ page }: CareersLayoutProps) {
  const careersPage = page as CareersPage;
  const pathname = usePathname();

  return (
    <>
      <PageBodyBackground heroId="hero-careers" />
      
      {/* Hero Section */}
      <HeroCareers id="hero-careers" />
      <ScrollForMoreOverlay />

      {/* Three Cards Section */}
      <ThreeCardsStickyMobile />

      <div className="h-[4px] lg:h-[7.5rem]"></div>
      
      {/* Negative margin to accommodate for the mandatory margin on the last card in ThreeCardsStickyMobile.tsx on mobile */}
      <div className="-mt-24 block md:hidden"></div>

      {/* Our Commitments Section */}
      <ListAccordion />
      
      <div className="h-[5.1875rem] lg:h-[4.6875rem]"></div>

      {/* Join our team and images with wavy background */}
      <ImagesWavyBg ctaLink="https://wd3.myworkdaysite.com/en-US/recruiting/havas/CreativeExternalCareerSite" pathname={pathname} />

      <div className="mb-8"></div>
      
      {/* Cookies */}
      <Cookies />
    </>
  );
}


